module.exports = __webpack_public_path__ + "static/media/probio1001.2b2572ae.pdf";